<template>
  <el-dialog
    class="importBillDialog"
    center
    title="自动对账"
    :visible.sync="visible"
    @close="cancel"
    :close-on-click-modal="false"
  >
    <el-alert class="alert" title type="info" :closable="false" show-icon>
      <span>提示:导入线下台账与网点推送账单进行比对，支持运单号、重量、目的省份对比，导入文件至少包含运单号</span>
    </el-alert>
    <div class="yto-title">下载对账模板</div>
    <div class="parent-box left right">
      <dt class="imgdt"  @mouseenter="iconName = 'selecter'" @mouseleave="iconName = ''">
        <svg-icon v-if="iconName === 'selecter'" icon-class="icon_template_ai_pre" class="tempIcon"></svg-icon>
        <svg-icon v-else icon-class="icon_template_ai_def" class="tempIcon"></svg-icon>
        <div class="y-fc-666 y-fw-700 normalColor">对账模板</div>
      </dt>
      <dt class="imgdt-bottom" @click="download">下载模板</dt>
    </div>
    <div class="yto-title">选择导入文件</div>
    <el-upload
      class="y-ml-30"
      ref="upload"
      action=""
      accept=".xls,.xlsx"
      :limit="1"
      :on-exceed="overLimit"
      :file-list="fileList"
      :multiple="false"
      :auto-upload="false"
      :http-request="chooseUploadFile">
      <el-button slot="trigger" size="small" class="normal-btn" style="float: left;vertical-align: middle;">上传文件</el-button>
      <div slot="tip" class="el-upload__tip">提示：单次导入最多10万条</div>
    </el-upload>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel()" palin>取 消</el-button>
      <el-button :loading="importLoading" type="primary" @click="importTpl">开始对账</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getStore } from '@/utils/localStorage';
import {autoReconciliationApi } from '../../../../api/finance/billStatistics/ordinaryBill';
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      headers: {
        'source': 'YTO-STEWARD',
        'jwt-token': getStore('stewoard-token')
      },
      importLoading: false,
      fileList: [],
      iconName:''
    }
  },
  watch: {
    show() {
      this.visible = this.show;
      this.fileList = [];
    }
  },
  methods: {
    // 上传文件个数限制
    overLimit() {
      this.$message({
        type: 'warning',
        message: '一次只能上传一个文件！'
      });
    },
    // 上传文件
    chooseUploadFile(params) {
      let file = params.file;
      // var isLt100M = file.size / 1024 / 1024 < 100;
      // if (!isLt100M) {
      //   this.$message.error('上传文件大小不能超过100MB!');
      //   return;
      // }
      let formData = new FormData();
      formData.append('file', file);
      formData.append('billingNo', this.info.billingNo);
      formData.append('customerCode', this.info.code);
      formData.append('orgCodes', this.info.createOrgCode);
      formData.append('billCreateTime', this.info.createTime);
      formData.append('total', this.info.total);
      formData.append('billingStatus', this.info.billingStatus);
      let loadingMask = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      this.importLoading = true;
       autoReconciliationApi(formData, {
        timeout: 1200000,
        headers: {
          'source': 'YTO-STEWARD',
          'jwt-token': getStore('stewoard-token'),
          'Content-Type': 'multipart/form-data; charset=utf-8'
        }
      }).then( (res) => {
        loadingMask.close();
        this.importLoading = false;
        if(res.status == 40366){
          this.$alert(res.message, '提示', {
            confirmButtonText: '前往下载中心',
            type: 'warning',
            center: true
          }).then(() => {
            this.$router.push('/dataCenter/downloadCenter');
          }).catch(() => {});
        }else if(res.status == 200 && res.data && res.data.version){
          let version = res.data.version || '';
          // this.$router.push({
          //   path:'/finance/ordinaryBill/autoVerifyBill',
          //   query:{
          //     version:version,
          //     source:'importBill'
          //   }
          // });
          this.cancel();// 跳转时关闭弹层 
          window.open(location.origin+'/new/finance/ordinaryBill/autoVerifyBill?source=importBill&version='+version);
        }else{
          this.$message.error(res.message);
        }
      })
      .catch(()=>{
        loadingMask.close();
        this.importLoading = false;
      })
    },
    cancel(){
      this.$emit('update:show', false);
      this.fileList = [];
    },
    importTpl() {
      // 导入
      if (this.$refs['upload'].uploadFiles.length === 0) {
        this.$message({
          type: 'warning',
          message: '请先上传文件'
        });
        return false;
      }
      this.$refs.upload.submit();
    },
    download() {
      // 下载模板
      let dom = document.createElement('a');
      dom.download = '';
      dom.href = '/new/static/templates/客户管家普通账单导入模板.xlsx';
      document.body.appendChild(dom);
      dom.click();
      dom.remove();
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../styles/variables";
.importBillDialog{
  .yto-title {
    color: #333;
  }
  .parent-box {
    box-sizing: border-box;
    width:116px;
    height: 146px;
    border-radius: 3px;
    text-align: center;
    cursor: pointer;
    margin-top: 5px;
    margin-bottom: 15px;
    box-shadow: 0px 0px 10px 0px rgba(109, 140, 209, 0.12);
    border-radius: 3px;
    &.left {
      margin-left: 30px;
    }
    &.right {
      margin-right: 30px;
    }
  }
  .imgdt {
    position: relative;
    box-sizing: border-box;
    height:116px;
    text-align: center;
  }
  .imgdt-bottom {
    margin: 0 7px;
    height: 29px;
    line-height: 29px;
    color: #999999;
    font-size: 14px;
    border-top: 1px solid #E5E5E5;
  }
  .imgdt:hover, .imgdt:active, .imgdt.active{
    border-color: $blue-style;
    background-color: $blue-style;
    box-shadow: 0px 2px 15px 0px rgba(109, 140, 209, 0.12);
    font-size: 12px;
    .normalColor {
      color: $white;
    }
    .grayColor {
      color: $white;
    }
  }
  .tempIcon {
    width: 31px!important;
    height: 36px!important;
    margin-top: 19px;
    margin-bottom: 15px;
  }
  /deep/ .el-list-enter-active,
  /deep/ .el-list-leave-active {
    transition: none;
  }

  /deep/ .el-list-enter,
  /deep/ .el-list-leave-active {
    opacity: 0;
  }
  /deep/ .el-upload-list {
    height: 40px;
  }
}
</style>
